<div class="container">
  <form>
      <div class="row">
        <mat-label>{{'resetPassword.lblNewPassword' | translate}} :</mat-label>
        <mat-form-field appearance="outline" class="col-12">
          <input name="password" [type]="!isPasswordVisible ? 'password' : 'text'" placeholder="{{'resetPassword.lblNewPassword' | translate}}" matInput required [(ngModel)]="resetPassword.newPassword">
          <mat-icon class="clickable" matSuffix (click)="isPasswordVisible = !isPasswordVisible">{{!isPasswordVisible? 'visibility_off' : 'visibility'}}</mat-icon>
          <mat-error>{{'errRequired' | translate}}</mat-error>
        </mat-form-field>
      </div>
      <div class="row">
        <mat-label>{{'resetPassword.lblConPassword' | translate}} :</mat-label>
        <mat-form-field appearance="outline" class="col-12">
          <input name="confirmPassword" [type]="!isPasswordVisible ? 'password' : 'text'" placeholder="{{'resetPassword.lblConPassword' | translate}}" matInput required [(ngModel)]="resetPassword.newConfirmPassword">
          <mat-error>{{'errRequired' | translate}}</mat-error>
        </mat-form-field>
      </div>
    <div class="row">
      <button mat-raised-button color="primary" type="button" (click)="OnSubmitClick()">{{'btnSubmit' | translate}}</button>
    </div>
  </form>
</div>